'use strict';

export function ngKeyEvents(utilsModule) {
  // The directives available:
  const enterAndArrows = [
    {directiveName: 'ngEnter', keyCode: 13},
    {directiveName: 'ngUpArrow', keyCode: 38},
    {directiveName: 'ngDownArrow', keyCode: 40},
  ];

  const backAndDelete = [
    {directiveName: 'ngBackspace', keyCode: 8},
    {directiveName: 'ngDelete', keyCode: 46},
  ];

  // Build the directives on the module

  enterAndArrows.map(({directiveName, keyCode}) =>
    utilsModule.directive(directiveName, () =>
      /* Directive link function */
      (scope, element, attrs) => {
        element.bind('keydown keypress', onEnterAndArrows(directiveName, scope, attrs, keyCode));
      }
    )
  );

  function onEnterAndArrows(directiveName, scope, attrs, keyCode) {
    return event => {
      if (event.which === keyCode) {
        scope.$apply(() => scope.$eval(attrs[directiveName]));
        event.preventDefault();
      }
    };
  }

  backAndDelete.map(({directiveName, keyCode}) =>
    utilsModule.directive(directiveName, () =>
      /* Directive link function */
      (scope, element, attrs) => {
        element.bind('keydown keypress', onBackAndDelete(directiveName, scope, attrs, keyCode));
      }
    )
  );

  function onBackAndDelete(directiveName, scope, attrs, keyCode) {
    return event => {
      if (event.which === keyCode) {
        scope.$apply(() => {
          if (scope.$eval(attrs[directiveName]) === true) {
            event.preventDefault();
          }
        });
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/misc-utils/ngKeyEvents.js